import { Component, OnInit } from '@angular/core';
import { MonedoService } from 'src/app/core/services/monedo.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Subscription } from 'rxjs/internal/Subscription';
import { Router } from '@angular/router';

@Component({
  selector: 'app-consent',
  templateUrl: './consent.component.html',
  styleUrl: './consent.component.scss'
})
export class ConsentComponent implements OnInit {

  consentUrl: SafeResourceUrl = '';
  private sseSub?: Subscription;
  loanId: string = '';
  constructor(private monedoServive: MonedoService, private sanitizer: DomSanitizer, private router: Router) { }
  ngOnInit(): void {
    this.monedoServive.InitiateConsent({ lat: 10, lon: 10 }).subscribe(response => {
      if (response['data'] != null) {
        this.consentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(response['data']['redirect_url']);
        this.loanId = response['data']['loan_id'];
      }

      this.sseSub = this.monedoServive.getServerUpdates(this.loanId, "consent")
        .subscribe({
          next: (event) => {

            //console.log('SSE message:', event);
            if (event === 'success') {
              this.router.navigateByUrl('/assist-journey/assist-underwrite');
            }
          },
          error: (err) => {
            this.router.navigateByUrl('/assist-journey/session-expired');
          }
        });

    });


  }
}
